import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Scroll() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when route changes
  }, [location]);

  return null;
}

export default Scroll;
